<template lang="pug">
  #EventActivityIndex.container-width
    div
    .d-flex.align-items-center.justify-content-center(style="color: #fff; background: #000; padding: 10px; width: 100%; font-size: 1.2rem; height: 50px; font-weight: bold;") 我的預約
    .d-flex.text-center(style="padding-top: 30px;")
      .w-100
        span.reservationTag(@click="changeSelectStatus(1)" :class="{'selectedTab': selectStatus === 1}") 完成預約
      .w-100
        span.reservationTag(@click="changeSelectStatus(2)" :class="{'selectedTab': selectStatus === 2}") 預約記錄
    .multiselect_custom_storeReservationList.mt-3(v-if="selectStatus === 2")
      multiselect(
        placeholder="請選擇預約月份",
        :options="monthOptions",
        :searchable="false",
        :allow-empty="false",
        label="name"
        v-model="nowSelectMonth",
        selectLabel='',
        deselect-label='',
        @input='resetData'
      )
    div.position-relative(style="padding: 20px; padding-bottom: 10%;")
      .reservationList(v-if="eventActivityList")
        .reservationItem(v-for="(event, index) in eventActivityList")
          .mb-2.pb-2(style="font-size: 1.2rem; font-weight: bold; border-bottom: 1px solid #000;") {{ event.reserves.name }}
          div 預約日期： {{ moment(event.reserve_start_at).format("YYYY-MM-DD") }}
          div 預約時間： {{ moment(event.reserve_start_at).format("HH:mm") }} {{ moment(event.reserve_end_at).format("HH:mm") }}
          div 預約專門店： {{ event.stores ? event.stores.title : '' }}
          div 預約狀態： {{ filterStatus(event.status) }}
          //div 付款狀態： {{ PayTypeList[event.payStatus] }}
          .d-flex.align-items-center.justify-content-center.mt-4(v-if="event.status === 2")
            button.btn.btn-custom(type="button", @click="cancel(event.id, index)", style="margin-right: 20px; width: 120px;")
              span 取消預約
            button.btn.btn-custom(type="button", @click="editHandler(event.id, index)", style="width: 120px;")
              span 修改預約

      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次

      .d-flex.justify-content-center
        button.btn.btn-custom(type="button", @click="backToLINEHandler()", style="width: 80%;") 返回官方帳號

</template>

<script>
import { mapState } from 'vuex';
import { M_EVENT_ACTIVITY_EDIT } from '@/router/member/event-activity';
import InfiniteLoading from 'vue-infinite-loading';

const moment = require('moment');

export default {
  name: 'EventActivityIndex',
  components: {
    InfiniteLoading
  },
  data() {
    return {
      nowSelect: 'checking',
      infiniteId: +new Date(),
      nowSelectMonth: null,
      monthOptions: [],
      isCallApi: false
    };
  },
  created() {
    const vm = this;
    vm.selectStatus = 1;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('member_event_activity/resetEventActivityList');
    vm.monthOptions = [];
    let i = 0;
    for (i = 0; i < 12; i++) {
      const month = moment(new Date()).subtract(i, 'months');
      const monthStart = moment(new Date()).subtract(i, 'months').startOf('month').format('YYYY-MM-DD');
      const monthEnd = moment(new Date()).subtract(i, 'months').endOf('month').format('YYYY-MM-DD');

      vm.monthOptions.push(
        {
          name: `${month.month() + 1}月`,
          value: `reserve_start_at=${monthStart}&reserve_end_at=${monthEnd}`
        }
      );
      if (i === 0) {
        vm.nowSelectMonth = {
          name: `${month.month() + 1}月`,
          value: `reserve_start_at=${monthStart}&reserve_end_at=${monthEnd}`
        };
      }
    }
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    moment(time) {
      return moment(time);
    },
    infiniteHandler($state) {
      const vm = this;
      const query = `${vm.selectStatus === 1 ? 'status=2&' : ''}current_page=${vm.pagination.current_page + 1}&per_page=${vm.pagination.per_page}${vm.nowSelectMonth ? `&${vm.nowSelectMonth.value}` : ''}`;
      vm.$store.dispatch('member_event_activity/getEventActivityListHandler', query).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    filterStatus(val) {
      switch (val) {
        case 2:
          return '完成預約';
        case 3:
          return '出席';
        case 4:
          return '未出席';
        case 5:
          return '取消預約';
        default:
          return '';
      }
    },
    changeSelectStatus(val) {
      const vm = this;
      vm.selectStatus = val;
      vm.$store.commit('member_event_activity/resetEventActivityList');
      vm.infiniteId += 1;
    },
    resetData() {
      const vm = this;
      vm.$store.commit('member_event_activity/resetEventActivityList');
      vm.infiniteId += 1;
    },
    cancel(id, index) {
      const vm = this;
      if (vm.isCallApi) return;
      vm.isCallApi = true;
      vm.$store.dispatch('member_event_activity/cancelEventActivityHandler', id).then(() => {
        vm.$snotify.success(null, '取消預約成功');
        vm.isCallApi = false;
        if (vm.selectStatus !== 2) {
          vm.$store.commit('member_event_activity/removeEventActivity', index);
        } else {
          vm.$store.commit('member_event_activity/updateEventActivity', { index, status: 5 });
        }
      }).catch(() => {
        vm.isCallApi = false;
      });
    },
    editHandler(id) {
      const vm = this;
      vm.$router.push({
        name: M_EVENT_ACTIVITY_EDIT,
        params: {
          id
        }
      });
    },
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  },
  computed: {
    ...mapState({
      eventActivityList: (state) => state.member_event_activity.eventActivityList,
      pagination: (state) => state.member_event_activity.pagination
    })
  }
};
</script>
<style  lang="scss">
  .multiselect_custom_storeReservationList {
    padding: 5px;
    background: #000;
    margin: 10px 0;
    & .multiselect__tags {
      border: solid 2px #aaa;
      background: #000;
      border-radius: 0;
    }
    & .multiselect__input,
    & .multiselect__single {
      background: #000;
      color: #fff;
    }
    & .multiselect__placeholder {
      background: #000;
      color: #fff;
    }
  }
</style>
<style scoped lang="scss">
  .reservationTag {
    padding: 10px;
    border-bottom: solid 3px transparent;
    &.selectedTab {
      border-bottom: solid 3px #000;
    }
  }

  .reservationList {
    margin: 20px 0;
    min-height: calc(100vh - 340px); // 扣除 header 我的預約 reservationTag multiselect 及 返回官方帳號的預留高度
    .reservationItem {
      text-align: left;
      margin: 10px 0;
      background: #eee;
      padding: 20px;
      & div {
        margin: 10px 0;
      }
    }
  }

  .btn-custom {
    color: #FFF;
    background-color: #000;
  }
</style>
